import React, {useEffect, useRef} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import emailjs from '@emailjs/browser';
import SafeIcon from '../common/SafeIcon';
import {saveSubmission} from '../data/submissions';

const {FiCheckCircle, FiArrowLeft, FiMail, FiGlobe} = FiIcons;

const ThankYouPage = ({prompt, onBack, answers}) => {
  const hasSent = useRef(false);

  useEffect(() => {
    if (hasSent.current) return;

    const serviceId = import.meta.env.VITE_EMAILJS_SERVICE_ID;
    const templateId = import.meta.env.VITE_EMAILJS_TEMPLATE_ID;
    const publicKey = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;
    const agencyEmail = import.meta.env.VITE_AGENCY_EMAIL;

    saveSubmission({answers, prompt});
    hasSent.current = true;

    if (!serviceId || !templateId || !publicKey || !agencyEmail) {
      console.error('EmailJS is missing a required configuration value.');
      return;
    }

    emailjs.send(
      serviceId,
      templateId,
      {
        to_email: agencyEmail.trim(),
        business_name: answers.businessName || 'New Project Request',
        business_email: answers.businessEmail || 'Not provided',
        industry: answers.industry || 'Not provided',
        prompt_content: prompt,
        reply_to: answers.businessEmail || agencyEmail.trim()
      },
      publicKey
    ).catch((error) => console.error('EmailJS submission failed:', error));
  }, [answers, prompt]);

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6">
      <motion.div initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}} className="max-w-2xl w-full bg-white rounded-3xl shadow-2xl border border-gray-100 p-12 text-center">
        <motion.div initial={{scale: 0}} animate={{scale: 1}} transition={{type: 'spring', damping: 12, stiffness: 200, delay: 0.2}} className="w-24 h-24 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-8">
          <SafeIcon icon={FiCheckCircle} className="text-green-500 text-5xl" />
        </motion.div>
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Thank you</h1>
        <p className="text-xl text-gray-600 mb-12 leading-relaxed">Submission received. Our team is now reviewing your information and will be in touch shortly</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12">
          <div className="p-4 bg-gray-50 rounded-2xl border border-gray-100 flex items-center gap-4 text-left">
            <div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600"><SafeIcon icon={FiMail} /></div>
            <div><p className="text-xs font-bold text-gray-400 uppercase tracking-wider">Next Step</p><p className="text-sm font-semibold text-gray-700">Email Confirmation</p></div>
          </div>
          <div className="p-4 bg-gray-50 rounded-2xl border border-gray-100 flex items-center gap-4 text-left">
            <div className="w-10 h-10 bg-purple-100 rounded-xl flex items-center justify-center text-purple-600"><SafeIcon icon={FiGlobe} /></div>
            <div><p className="text-xs font-bold text-gray-400 uppercase tracking-wider">Timeline</p><p className="text-sm font-semibold text-gray-700">24-48 Hour Review</p></div>
          </div>
        </div>
        <button onClick={onBack} className="inline-flex items-center gap-2 text-gray-500 hover:text-gray-900 font-medium transition-colors"><SafeIcon icon={FiArrowLeft} /> Return to Form</button>
      </motion.div>
    </div>
  );
};

export default ThankYouPage;